<template>
    <header>
        <div class="container"  v-click-outside="closeMenu">
            <div class="row justify-content-between">
                <div class="col-md-2 col-8">
                    <div class="logo">
                        <router-link :to="{name: 'index'}">
                          <img src="/img/header/logo.svg" alt="">
                        </router-link>
                    </div>
                </div>

                <div class="col-lg-9 align-items-center d-none d-lg-flex justify-content-center">
                    <div class="head__items">
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/shield.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">Elbyte med prisgaranti</p>
                            </div>
                        </div>
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/scales.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">Jämför och byt gratis </p>
                            </div>
                        </div>
                        <div class="head-item">
                            <div class="img">
                                <img src="/img/header/calendar.svg" alt="">
                            </div>
                            <div class="info">
                                <p class="min-min p-dgrey">14 dagars ångerrätt</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-2 d-flex align-items-center">
                    <div class="navs">
                        <div class="icon">
                            <button type="button" @click="openMenu" :class="{'open': navOpen }" class="closes nav-icon">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>

                        </div>
                        <p @click="openMenu">{{MenuName}}</p>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="nav-menu" v-if="navOpen">
                    <div class="layer"  @click="openMenu"></div>
                        <div class="main-menu menu__blck">
                            <div class="menu__blck">
                                <div class="menu-row">
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'companylist'}">
                                                FAQ
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'companylist'}">
                                                Companies
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'contact'}">
                                                Contact Us
                                            </router-link>
                                        </div>
                                    </div>

                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'about'}">
                                                About us
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'terms'}">
                                                Cookiepolicy
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'terms'}">
                                                Användarvillkor
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="menu-col">
                                        <div class="item">
                                            <router-link :to="{name: 'terms'}">
                                                Personuppgiftspolicy
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </transition>
        </div>

    </header>
</template>

<script>
    export default {
        name: "HeadBlock",
        data: function(){
          return {
              navOpen:false,
              MenuName: 'MENY'
          }
        },
        methods: {
            openMenu: function(){
                if(this.navOpen){
                    this.navOpen = false;
                    this.unblockScroll();
                    this.MenuName = 'MENY';
                } else {
                    this.navOpen = true;
                    this.MenuName = 'STÄNG';
                    this.blockScroll()
                }

            },
            blockScroll(){

                let div = document.createElement('div');
                document.body.append(div);

                let paddingRight = window.innerWidth - div.offsetWidth;
                let scroll = window.scrollY;

                div.remove();

                document.body.classList.add('no-scroll');
                document.body.style.top = `-${scroll}px`;
                document.body.style.paddingRight = paddingRight + 'px';
            },
            unblockScroll(){
                const scrollY = document.body.style.top;
                document.body.classList.remove('no-scroll');
                document.body.style.paddingRight = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    }
</script>
